import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { internalMessageBus } from "sb-internal-msg-bus";
import { dict } from "./dict";
import { config } from "./config";
import { SportScoreboards } from "./ui";
import { SportScoreboardsState } from "./state";
import { ScoreboardParser } from "./../../ScoreboardParser";
import { EventRetriever } from "../../EventRetriever";
import { SportConnection } from "../../SportConnection";
import { ActivationManager, Registry } from "../../utils";
let mocks;
if (process.env.NODE_ENV === "development") {
    mocks = require("../../mocks");
    window["SportEventMap"] = mocks.SportEventsMap;
}
export class SportScoreboardsRoot extends BaseBlock {
    constructor(domId, options) {
        super(domId, options);
        let sportConnection;
        options.cms = Object.assign(Object.assign({}, config), (options.cms || {}));
        options.dict = Object.assign(Object.assign({}, dict), (options.dict || {}));
        if (process.env.NODE_ENV === "development") {
            sportConnection = new mocks.SportConnectionMock(mocks.SportEventsMap);
        }
        if (process.env.NODE_ENV === "production") {
            sportConnection = new SportConnection();
        }
        this.dataProvider = new SportScoreboardsState({
            cms: options.cms,
            dict: options.dict,
            uniqueBlockId: domId,
            parser: new ScoreboardParser({
                retriever: new EventRetriever({
                    activationManager: new ActivationManager(new Registry()),
                    sportConnection,
                    messageBus: internalMessageBus
                }),
                messageBus: internalMessageBus
            })
        });
        this.props = { dataProvider: this.dataProvider };
    }
    activate() {
        return super.activate(React.createElement(SportScoreboards, Object.assign({}, this.props)));
    }
}
window["SportScoreboards"] = SportScoreboardsRoot;
broadcastBlockLoad("SportScoreboards");
//# sourceMappingURL=index.js.map